import * as React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

interface PlaylistLoaderProps {}

const PlaylistLoader: React.FC<PlaylistLoaderProps> = props => {
  const { colors } = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={400}
      height={800}
      viewBox="0 0 400 800"
      backgroundColor={colors.primary}
      foregroundColor={colors.activeLink}
      {...props}
    >
      <circle cx="60" cy="48" r="32" />
      <circle cx="60" cy="148" r="32" />
      <circle cx="60" cy="248" r="32" />
      <circle cx="60" cy="348" r="32" />
      <circle cx="60" cy="448" r="32" />
      <circle cx="60" cy="548" r="32" />
      <circle cx="60" cy="648" r="32" />
      <rect x="125" y="33" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="53" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="133" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="153" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="233" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="253" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="333" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="353" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="433" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="453" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="533" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="553" rx="3" ry="3" width="284" height="9" />
      <rect x="125" y="633" rx="3" ry="3" width="119" height="9" />
      <rect x="125" y="653" rx="3" ry="3" width="284" height="9" />
    </ContentLoader>
  );
};

export default PlaylistLoader;
